// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { AnalyticsPost } from '../../../../types/server/modules/analytics/post';

export type * from '../../../../types/server/modules/analytics/post';

export const createPost = ( requests: Requests ): AnalyticsPost => ({
  generate_report: Object.assign(( body,headers ) => {
      return requests.post( `/analytics/generate-report`, { body }, headers );
    }, { operation: 'analytics:generate-report', route: 'POST /analytics/generate-report', subdomain: 'analytics', visibility: 'private' } as const )
});
